import { render } from "./FileBar.vue?vue&type=template&id=80f66b12"
import script from "./FileBar.vue?vue&type=script&lang=js"
export * from "./FileBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__